import script from "./add-point.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-point.vue?vue&type=script&lang=ts&setup=true"

import "./add-point.vue?vue&type=style&index=0&id=081ea742&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081ea742"]])

export default __exports__